import { Link } from 'react-router-dom';
import SEOHead from '../../components/base/SEOHead';
import Header from '../../components/feature/Header';

export default function Recruit() {
  const recruitSchema = [
    {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "title": "交通誘導警備スタッフ",
      "description": "倉敷市内の道路工事現場や建設現場で交通誘導業務を行っていただきます。未経験の方も丁寧に指導しますので、安心してご応募ください。",
      "datePosted": "2025-01-15",
      "validThrough": "2025-12-31",
      "employmentType": ["FULL_TIME", "PART_TIME"],
      "hiringOrganization": {
        "@type": "Organization",
        "name": "おかやま警備株式会社",
        "sameAs": "SITE_URL_PLACEHOLDER/"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "倉敷市",
          "addressRegion": "岡山県",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "minValue": 9000,
          "maxValue": 12000,
          "unitText": "DAY"
        }
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "title": "イベント警備スタッフ",
      "description": "倉敷市内で開催される祭りやイベントでの駐車場誘導や交通整理を行っていただきます。土日のみの勤務も可能です。",
      "datePosted": "2025-01-15",
      "validThrough": "2025-12-31",
      "employmentType": ["PART_TIME", "TEMPORARY"],
      "hiringOrganization": {
        "@type": "Organization",
        "name": "おかやま警備株式会社",
        "sameAs": "SITE_URL_PLACEHOLDER/"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "倉敷市",
          "addressRegion": "岡山県",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "minValue": 1100,
          "maxValue": 1400,
          "unitText": "HOUR"
        }
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "title": "警備責任者候補",
      "description": "現場の管理や新人教育を担当していただく責任者候補を募集します。警備業務の経験者を優遇します。",
      "datePosted": "2025-01-15",
      "validThrough": "2025-12-31",
      "employmentType": "FULL_TIME",
      "hiringOrganization": {
        "@type": "Organization",
        "name": "おかやま警備株式会社",
        "sameAs": "SITE_URL_PLACEHOLDER/"
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "倉敷市",
          "addressRegion": "岡山県",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "minValue": 220000,
          "maxValue": 300000,
          "unitText": "MONTH"
        }
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "ホーム",
          "item": "SITE_URL_PLACEHOLDER/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "求人情報",
          "item": "SITE_URL_PLACEHOLDER/recruit"
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="求人情報｜交通誘導警備スタッフ募集｜おかやま警備株式会社｜倉敷市"
        description="おかやま警備株式会社の求人情報。倉敷市を中心に交通誘導警備スタッフを募集中。未経験者歓迎、丁寧な研修制度あり。正社員・パート・アルバイト募集。週2日からOK。日給9,000円〜12,000円。資格取得支援制度あり。地域密着で働きやすい環境です。"
        keywords="求人情報,採用,交通誘導警備,警備員募集,倉敷市,アルバイト,パート,正社員,未経験歓迎"
        canonical="/recruit"
        schema={recruitSchema}
      />
      <Header />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-cover bg-center" style={{backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/f4a0181a3cab9fd9e38194eec895b273.jpg')`}}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">求人情報</h1>
          <p className="text-xl md:text-2xl text-white">一緒に倉敷の安全を担う仲間を募集しています</p>
        </div>
      </section>

      {/* Recruitment Message */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">私たちと一緒に働きませんか</h2>
          <p className="text-xl text-gray-700 leading-relaxed mb-8">おかやま警備株式会社では、倉敷市を中心に交通誘導警備のスタッフを募集しています。未経験の方も大歓迎です。丁寧な研修制度があり、先輩スタッフがしっかりサポートしますので、安心してスタートできます。地域の安全を守るやりがいのある仕事で、一緒に成長していきましょう。</p>
        </div>
      </section>

      {/* Job Benefits */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">働く魅力</h2>
            <p className="text-xl text-gray-600">おかやま警備で働く6つのメリット</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">未経験者歓迎</h3>
              <p className="text-gray-700 leading-relaxed">警備業務が初めての方も安心してスタートできます。充実した研修制度と先輩スタッフのサポートで、基礎から丁寧に指導します。交通誘導警備の資格取得も会社がバックアップします。</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-time-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">柔軟な勤務時間</h3>
              <p className="text-gray-700 leading-relaxed">フルタイムからパートタイムまで、ライフスタイルに合わせた働き方が可能です。週2日からの勤務もOK。シフト制なので、プライベートとの両立もしやすい環境です。</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-map-pin-user-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">地域密着の仕事</h3>
              <p className="text-gray-700 leading-relaxed">倉敷市を中心とした地域での勤務なので、通勤も便利です。地元で働きたい方、地域貢献したい方に最適な職場環境です。現場も倉敷市内が中心なので移動時間も少なくて済みます。</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-award-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">資格取得支援</h3>
              <p className="text-gray-700 leading-relaxed">交通誘導警備業務検定などの資格取得を会社が全面的にサポート。資格取得後は手当も支給されます。スキルアップしながら収入アップも目指せます。</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-team-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">アットホームな職場</h3>
              <p className="text-gray-700 leading-relaxed">少人数の会社だからこそ、スタッフ同士の距離が近く、相談しやすい環境です。年齢や経験に関係なく、みんなで協力し合いながら働いています。</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-md">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-3xl text-blue-900"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">充実の福利厚生</h3>
              <p className="text-gray-700 leading-relaxed">社会保険完備、交通費支給、制服貸与など、安心して働ける環境を整えています。長く働いていただけるよう、働きやすい職場づくりに力を入れています。</p>
            </div>
          </div>
        </div>
      </section>

      {/* Job Listings */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">募集職種</h2>
            <p className="text-xl text-gray-600">現在募集中の職種一覧</p>
          </div>
          
          <div className="space-y-8">
            {/* Job 1 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg">
              <div className="md:flex">
                <div className="md:w-1/3">
                  <img src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20security%20guard%20in%20orange%20safety%20vest%20directing%20traffic%20at%20construction%20site%2C%20confident%20posture%2C%20professional%20work%20environment%2C%20daytime%20clear%20weather%2C%20realistic%20photography%20style%2C%20high%20quality&width=600&height=400&seq=job001&orientation=landscape" alt="交通誘導警備スタッフ" className="w-full h-64 md:h-full object-cover object-top" />
                </div>
                <div className="p-8 md:w-2/3">
                  <div className="inline-block bg-blue-900 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">正社員・パート</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">交通誘導警備スタッフ</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">倉敷市内の道路工事現場や建設現場で交通誘導業務を行っていただきます。未経験の方も丁寧に指導しますので、安心してご応募ください。</p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-money-dollar-circle-line text-blue-900 mr-2"></i>給与
                      </h4>
                      <p className="text-gray-700 text-sm">日給9,000円〜12,000円<br />（経験・資格により優遇）</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-time-line text-blue-900 mr-2"></i>勤務時間
                      </h4>
                      <p className="text-gray-700 text-sm">8:00〜17:00（実働8時間）<br />※現場により変動あり</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-calendar-line text-blue-900 mr-2"></i>勤務日数
                      </h4>
                      <p className="text-gray-700 text-sm">週2日〜OK<br />シフト制（応相談）</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-map-pin-line text-blue-900 mr-2"></i>勤務地
                      </h4>
                      <p className="text-gray-700 text-sm">倉敷市内を中心とした<br />岡山県内の各現場</p>
                    </div>
                  </div>
                  <div className="mb-6">
                    <h4 className="font-semibold text-gray-900 mb-2">応募資格</h4>
                    <ul className="text-gray-700 text-sm space-y-1">
                      <li>・18歳以上の方（高校生不可）</li>
                      <li>・未経験者歓迎</li>
                      <li>・交通誘導警備業務検定資格者優遇</li>
                      <li>・普通自動車免許あれば尚可</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">待遇・福利厚生</h4>
                    <ul className="text-gray-700 text-sm space-y-1">
                      <li>・社会保険完備（正社員）</li>
                      <li>・交通費支給</li>
                      <li>・制服貸与</li>
                      <li>・資格取得支援制度</li>
                      <li>・資格手当あり</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Job 2 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg">
              <div className="md:flex">
                <div className="md:w-1/3">
                  <img src="https://readdy.ai/api/search-image?query=Professional%20Japanese%20female%20security%20staff%20in%20uniform%20managing%20event%20parking%20area%20with%20friendly%20smile%2C%20organized%20outdoor%20event%20setting%2C%20daytime%20bright%20atmosphere%2C%20professional%20photography%2C%20realistic%20high%20quality&width=600&height=400&seq=job002&orientation=landscape" alt="イベント警備スタッフ" className="w-full h-64 md:h-full object-cover object-top" />
                </div>
                <div className="p-8 md:w-2/3">
                  <div className="inline-block bg-green-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">アルバイト・パート</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">イベント警備スタッフ</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">倉敷市内で開催される祭りやイベントでの駐車場誘導や交通整理を行っていただきます。土日のみの勤務も可能です。</p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-money-dollar-circle-line text-blue-900 mr-2"></i>給与
                      </h4>
                      <p className="text-gray-700 text-sm">時給1,100円〜1,400円<br />（経験により優遇）</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-time-line text-blue-900 mr-2"></i>勤務時間
                      </h4>
                      <p className="text-gray-700 text-sm">イベントにより変動<br />（4時間〜8時間程度）</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-calendar-line text-blue-900 mr-2"></i>勤務日数
                      </h4>
                      <p className="text-gray-700 text-sm">土日祝中心<br />単発勤務OK</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-map-pin-line text-blue-900 mr-2"></i>勤務地
                      </h4>
                      <p className="text-gray-700 text-sm">倉敷市内の<br />各イベント会場</p>
                    </div>
                  </div>
                  <div className="mb-6">
                    <h4 className="font-semibold text-gray-900 mb-2">応募資格</h4>
                    <ul className="text-gray-700 text-sm space-y-1">
                      <li>・18歳以上の方（高校生不可）</li>
                      <li>・未経験者大歓迎</li>
                      <li>・学生・主婦（夫）・シニアの方も活躍中</li>
                      <li>・土日のみの勤務も可能</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">待遇・福利厚生</h4>
                    <ul className="text-gray-700 text-sm space-y-1">
                      <li>・交通費支給</li>
                      <li>・制服貸与</li>
                      <li>・単発勤務OK</li>
                      <li>・研修制度あり</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Job 3 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-lg">
              <div className="md:flex">
                <div className="md:w-1/3">
                  <img src="https://readdy.ai/api/search-image?query=Experienced%20Japanese%20male%20security%20supervisor%20in%20professional%20uniform%20reviewing%20documents%20at%20construction%20site%2C%20leadership%20posture%2C%20organized%20work%20environment%2C%20professional%20photography%20style%2C%20realistic%20high%20quality&width=600&height=400&seq=job003&orientation=landscape" alt="警備責任者候補" className="w-full h-64 md:h-full object-cover object-top" />
                </div>
                <div className="p-8 md:w-2/3">
                  <div className="inline-block bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">正社員</div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">警備責任者候補</h3>
                  <p className="text-gray-700 leading-relaxed mb-6">現場の管理や新人教育を担当していただく責任者候補を募集します。警備業務の経験者を優遇します。</p>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-money-dollar-circle-line text-blue-900 mr-2"></i>給与
                      </h4>
                      <p className="text-gray-700 text-sm">月給22万円〜30万円<br />（経験・資格により優遇）</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-time-line text-blue-900 mr-2"></i>勤務時間
                      </h4>
                      <p className="text-gray-700 text-sm">8:00〜17:00<br />（実働8時間）</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-calendar-line text-blue-900 mr-2"></i>休日
                      </h4>
                      <p className="text-gray-700 text-sm">週休2日制<br />（日曜・祝日）</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2 flex items-center">
                        <i className="ri-map-pin-line text-blue-900 mr-2"></i>勤務地
                      </h4>
                      <p className="text-gray-700 text-sm">本社および<br />倉敷市内の各現場</p>
                    </div>
                  </div>
                  <div className="mb-6">
                    <h4 className="font-semibold text-gray-900 mb-2">応募資格</h4>
                    <ul className="text-gray-700 text-sm space-y-1">
                      <li>・警備業務経験3年以上</li>
                      <li>・交通誘導警備業務検定1級または2級保持者</li>
                      <li>・普通自動車免許必須</li>
                      <li>・マネジメント経験者優遇</li>
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">待遇・福利厚生</h4>
                    <ul className="text-gray-700 text-sm space-y-1">
                      <li>・社会保険完備</li>
                      <li>・交通費全額支給</li>
                      <li>・制服貸与</li>
                      <li>・資格手当あり</li>
                      <li>・昇給・賞与あり</li>
                      <li>・退職金制度あり</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Application Process */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">応募の流れ</h2>
            <p className="text-xl text-gray-600">ご応募から入社までの流れ</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">1</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">応募</h3>
              <p className="text-gray-600 text-sm leading-relaxed">お電話またはお問い合わせフォームからご連絡ください。履歴書不要で気軽にご応募いただけます。</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">2</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">面接</h3>
              <p className="text-gray-600 text-sm leading-relaxed">本社にて面接を実施します。服装自由、リラックスしてお越しください。ご希望の働き方などをお聞かせください。</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">3</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">研修</h3>
              <p className="text-gray-600 text-sm leading-relaxed">警備業務の基礎から丁寧に指導します。先輩スタッフが同行しますので、未経験の方も安心です。</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-900 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">4</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">勤務開始</h3>
              <p className="text-gray-600 text-sm leading-relaxed">研修終了後、実際の現場で勤務開始です。困ったことがあればいつでも相談できる環境です。</p>
            </div>
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">応募フォーム</h2>
            <p className="text-xl text-gray-600">下記フォームよりお気軽にご応募ください</p>
          </div>
          <div className="bg-gray-50 rounded-xl p-8 md:p-12">
            <form data-readdy-form id="recruit-form" className="space-y-6" action="https://readdy.ai/api/form/d4ja8cqeh8g2mrj4avf1" method="POST" onSubmit={(e) => {
              e.preventDefault();
              const form = e.currentTarget;
              
              // テキストエリアの文字数チェック
              const messageTextarea = form.querySelector('#message') as HTMLTextAreaElement;
              if (messageTextarea && messageTextarea.value.length > 500) {
                alert('自己PR・質問などは500文字以内で入力してください。');
                return;
              }
              
              const formData = new FormData(form);
              const data = new URLSearchParams();
              
              formData.forEach((value, key) => {
                if (key === 'position' || key === 'experience') {
                  const select = form.querySelector(`#${key}`) as HTMLSelectElement;
                  if (select && select.value) {
                    data.append(key, select.options[select.selectedIndex].text);
                  }
                } else {
                  data.append(key, value.toString());
                }
              });
              
              fetch('https://readdy.ai/api/form/d4ja8cqeh8g2mrj4avf1', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: data.toString()
              }).then(response => {
                if (response.ok) {
                  alert('応募を受け付けました。ありがとうございます。');
                  form.reset();
                } else {
                  alert('送信に失敗しました。もう一度お試しください。');
                }
              }).catch(() => {
                alert('送信に失敗しました。もう一度お試しください。');
              });
            }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2">お名前 <span className="text-red-600">*</span></label>
                  <input type="text" id="name" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
                <div>
                  <label htmlFor="age" className="block text-sm font-semibold text-gray-900 mb-2">年齢</label>
                  <input type="number" id="age" name="age" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2">メールアドレス <span className="text-red-600">*</span></label>
                  <input type="email" id="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-sm font-semibold text-gray-900 mb-2">電話番号 <span className="text-red-600">*</span></label>
                  <input type="tel" id="phone" name="phone" required className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm" />
                </div>
              </div>
              <div>
                <label htmlFor="position" className="block text-sm font-semibold text-gray-900 mb-2">希望職種 <span className="text-red-600">*</span></label>
                <div className="relative">
                  <select id="position" name="position" required className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent appearance-none cursor-pointer text-sm bg-white">
                    <option value="">選択してください</option>
                    <option value="交通誘導警備スタッフ">交通誘導警備スタッフ</option>
                    <option value="イベント警備スタッフ">イベント警備スタッフ</option>
                    <option value="警備責任者候補">警備責任者候補</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-600"></i>
                </div>
              </div>
              <div>
                <label htmlFor="experience" className="block text-sm font-semibold text-gray-900 mb-2">警備業務経験</label>
                <div className="relative">
                  <select id="experience" name="experience" className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent appearance-none cursor-pointer text-sm bg-white">
                    <option value="">選択してください</option>
                    <option value="未経験">未経験</option>
                    <option value="1年未満">1年未満</option>
                    <option value="1年以上3年未満">1年以上3年未満</option>
                    <option value="3年以上">3年以上</option>
                  </select>
                  <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-600"></i>
                </div>
              </div>
              <div>
                <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2">自己PR・質問など</label>
                <textarea id="message" name="message" rows={6} maxLength={500} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent text-sm resize-none" placeholder="志望動機や質問事項などをご記入ください（500文字以内）"></textarea>
                <p className="text-sm text-gray-600 mt-2">※500文字以内でご入力ください</p>
              </div>
              <button type="submit" className="w-full bg-blue-900 text-white py-4 rounded-lg font-semibold hover:bg-blue-800 transition-colors whitespace-nowrap cursor-pointer text-lg">
                応募する
              </button>
            </form>
            <div className="mt-8 pt-8 border-t border-gray-300 text-center">
              <p className="text-sm text-gray-600 mb-3">お電話でのお問い合わせも受け付けております</p>
              <a href="tel:086-012-3456" className="text-2xl font-bold text-blue-900 hover:text-blue-700 cursor-pointer whitespace-nowrap inline-flex items-center">
                <i className="ri-phone-fill mr-2"></i>086-012-3456
              </a>
              <p className="text-sm text-gray-600 mt-2">受付時間：9:00〜18:00（日曜・祝日を除く）</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-bold mb-4">おかやま警備株式会社</h3>
              <p className="text-gray-400 text-sm leading-relaxed">倉敷市を中心に、確かな技術と丁寧な対応で地域の安全を守ります。</p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">サービス</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">道路工事現場の交通誘導</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">建設現場の警備</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">イベント会場の交通整理</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white cursor-pointer">商業施設の駐車場警備</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">会社情報</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/company" className="text-gray-400 hover:text-white cursor-pointer">会社概要</Link></li>
                <li><Link to="/recruit" className="text-gray-400 hover:text-white cursor-pointer">求人情報</Link></li>
                <li><Link to="/blog" className="text-gray-400 hover:text-white cursor-pointer">ブログ・新着情報</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">お問い合わせ</h4>
              <ul className="space-y-2 text-sm">
                <li className="flex items-start">
                  <i className="ri-phone-fill mr-2 mt-1"></i>
                  <a href="tel:086-012-3456" className="text-gray-400 hover:text-white cursor-pointer">086-012-3456</a>
                </li>
                <li className="flex items-start">
                  <i className="ri-printer-fill mr-2 mt-1"></i>
                  <span className="text-gray-400">086-012-3457</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-fill mr-2 mt-1"></i>
                  <span className="text-gray-400">岡山市北区○○町1-2-3</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">&copy; 2025 おかやま警備株式会社. All rights reserved.</p>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm mt-4 md:mt-0 cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
